import { type ReactElement } from "react";
import { type ServerThreadStatus } from "./serverThreadStatus";
import { NoActiveThreadState } from "../NoActiveThreadState";

export function ChatThreadUnavailableSurface(props: {
  readonly routeKind: "server" | "draft";
  readonly serverThreadStatus: ServerThreadStatus;
  readonly serverThreadSubscriptionError: string | null;
}): ReactElement {
  if (props.routeKind !== "server") {
    return <NoActiveThreadState />;
  }

  const surfaceTitle =
    props.serverThreadStatus === "missing" ? "Thread unavailable" : "Loading thread...";
  const surfaceDescription =
    props.serverThreadStatus === "missing"
      ? (props.serverThreadSubscriptionError ?? "Thread not found or you no longer have access.")
      : "Forge is reconnecting this thread state.";

  return (
    <div
      className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-background"
      data-testid={
        props.serverThreadStatus === "missing"
          ? "server-thread-missing-surface"
          : "server-thread-loading-surface"
      }
    >
      <div className="flex flex-1 items-center justify-center px-6">
        <div className="max-w-md text-center">
          <p className="text-sm font-medium text-foreground">{surfaceTitle}</p>
          <p className="mt-2 text-sm text-muted-foreground">{surfaceDescription}</p>
        </div>
      </div>
    </div>
  );
}
